import {DocumentHistory} from "../models/document-history";
import {DocumentHistoryDto} from "../dto/document-history-dto";
import {RBCheck, RBConvert} from "@ldw/roesberg";

export class DocumentHistoryFactory {
  static fromDTO(dtoList: DocumentHistoryDto[]): DocumentHistory[] {
    const list: DocumentHistory[] = [];
    if (!RBCheck.isNullOrHasNoValues(dtoList)) {
      dtoList.forEach(dto => {
        const item = new DocumentHistory();
        item.archived = RBConvert.jsonUTCStringToString(dto.archived);
        item.changed = RBConvert.jsonUTCStringToString(dto.changed);
        item.changedBy = dto.changedBy;
        item.job = dto.job;
        item.fileName = dto.fileName;
        list.push(item);
      })
    }
    return list;
  }
}
